import React from "react";
import "./index.scss";
import { formatAmount } from "../../../../../utils/helper";

const InsuranceDetails = ({ product }) => {
  return (
    <div className="insurance--detail--wrapper" key={product.product_name}>
      <div className="details--wrapper--header">
        <div className="details--header--title">
          <h1 className="details--header--title--text">
            {product.product_name}
          </h1>
          <h3 className="details--header--subtitle--text">
            {product.oem_name}
          </h3>
        </div>
        <h3 className="details--header--price">
          {formatAmount(product.premium_amount)}
        </h3>
      </div>
    </div>
  );
};

export default InsuranceDetails;
